Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = trackEmailReferrer;

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function trackEmailReferrer(instance) {
  var params = _qs2['default'].parse(window.location.search.slice(1));
  if (params.euid) {
    instance.logEvent({
      event_name: 'email_referred_page_load',
      event_data: {
        channel: 'email',
        rookery_uuid: params.euid,
        rookery_link_uuid: params.eluid,
        url: window.location.href
      }
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-tracking/build/trackEmailReferrer.js
// module id = 480
// module chunks = 168707334958949